import type { TypedVerdict } from "@aybuben/core/writing/check.ts";

import { useStrings } from "../../i18n/index.tsx";
import { ARM, COL } from "../../theme.ts";

/**
 * "You wrote", with the letters that differ marked: the correct answer sits
 * right above it in the feedback panel, so this only has to say where.
 */
export function TypedDiff({ verdict }: { verdict: TypedVerdict }) {
	const t = useStrings();
	return (
		<div className="mt-1 text-sm" data-testid="typed-diff" style={{ color: COL.mute }}>
			{t("write.youWrote")}:{" "}
			<span style={{ fontFamily: ARM, fontSize: 22, color: COL.ink, whiteSpace: "pre-wrap" }}>
				{verdict.diff.map((p, i) => {
					switch (p.kind) {
						case "same":
							return <span key={i}>{p.text}</span>;
						case "wrong":
							return (
								<mark
									key={i}
									data-diff="wrong"
									style={{
										background: "transparent",
										color: COL.red,
										textDecoration: `underline 3px ${COL.red}`,
										textUnderlineOffset: 4,
									}}
								>
									{p.text}
								</mark>
							);
						case "extra":
							return (
								<del key={i} data-diff="extra" style={{ color: COL.redDark }}>
									{p.text}
								</del>
							);
						case "missing":
							return (
								<span key={i} data-diff="missing" aria-hidden="true" style={{ color: COL.red }}>
									_
								</span>
							);
					}
				})}
			</span>
		</div>
	);
}
